import { Modal, openLoginModalPayload } from "@/shared/interfaces/Modal.interface";
import { Picture } from "@/shared/interfaces/Picture.interface";
import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { RootState } from "../../store.interface";


const state: Modal = {
    isModalOpen: false,
    isLoginModalOpen: false,
    loginModalSuccessCallback: () => null,
    loginModalCancelCallback: () => null,
    isPictureModalOpen: false,
    isDeactivateModalOpen: false,
    isDeleteModalOpen: false,
    isReactivateModalOpen: false,
    isResetWizardModalOpen: false,
    isEditionModalOpen: false,
    isMasqueradeModalOpen: false,
    isWarningModalOpen: false,
    windowScrollBarWidth: 0,
    activePicture: null,
    canBeClosed: true,
    modalTitle: null
};

const mutations: MutationTree<Modal> =  {
    openModal: function(state: Modal): void {
        state.isModalOpen = true;
    },
    openLoginModal: function(state: Modal, payload?: openLoginModalPayload): void {
        state.isModalOpen = true;
        state.isLoginModalOpen = true;

        if (payload) {
            if (payload.successCallback) {
                state.loginModalSuccessCallback = payload.successCallback;
            }

            if (payload.cancelCallback) {
                state.loginModalCancelCallback = payload.cancelCallback;
            }
        }

    },
    openPictureModal: function(state: Modal, picture: Picture): void {
        state.activePicture = picture;
        state.isModalOpen = true;
        state.isPictureModalOpen = true;
    },
    openDeactivateModal: function(state: Modal): void {
        state.isModalOpen = true;
        state.isDeactivateModalOpen = true;
    },
    openDeleteModal: function(state: Modal): void {
        state.isModalOpen = true;
        state.isDeleteModalOpen = true;
    },
    openReactivateModal: function(state: Modal): void {
        state.isModalOpen = true;
        state.isReactivateModalOpen = true;
    },
    openResetWizardModal: function(state: Modal): void {
        state.isModalOpen = true;
        state.isResetWizardModalOpen = true;
    },
    openEditionModal: function(state: Modal): void {
        state.isModalOpen = true;
        state.isEditionModalOpen = true;
    },
    openMasqueradeModal: function(state: Modal): void {
        state.isModalOpen = true;
        state.isMasqueradeModalOpen = true;
    },
    openWarningModal: function(state: Modal): void {
        state.isModalOpen = true;
        state.isWarningModalOpen = true;
    },
    closeModal: function(state: Modal): void {
        state.isModalOpen = false;
    },
    closeLoginModal: function(state: Modal): void {
        state.isModalOpen = false;
        state.isLoginModalOpen = false;
        state.canBeClosed = true;
    },
    closeDeactivateModal: function(state: Modal): void {
        state.isModalOpen = false;
        state.isDeactivateModalOpen = false;
    },
    closeDeleteModal: function(state: Modal): void {
        state.isModalOpen = false;
        state.isDeleteModalOpen = false;
    },
    closeReactivateModal: function(state: Modal): void {
        state.isModalOpen = false;
        state.isReactivateModalOpen = false;
    },
    closeResetWizardModal: function(state: Modal): void {
        state.isModalOpen = false;
        state.isResetWizardModalOpen = false;
    },
    closePictureModal: function(state: Modal): void {
        state.isModalOpen = false;
        state.isPictureModalOpen = false;
    },
    closeEditionModal: function(state: Modal): void {
        state.isModalOpen = false;
        state.isEditionModalOpen = false;
    },
    closeMasqueradeModal: function(state: Modal): void {
        state.isModalOpen = false;
        state.isMasqueradeModalOpen = false;
    },
    closeWarningModal: function(state: Modal): void {
        state.isModalOpen = false;
        state.isWarningModalOpen = false;
    },
    setWindowScrollBarWidth: function(state: Modal, width: number): void {
        state.windowScrollBarWidth = width;
    },
    setCanBeClose: function(state: Modal, canBeClosed: boolean): void {
        state.canBeClosed = canBeClosed;
    },
    setModalTitle: function(state: Modal, title: string): void {
        state.modalTitle = title;
    }
};

const getters: GetterTree<Modal, RootState> = {
    isModalOpen: ((state: Modal): boolean => {
        return state.isModalOpen;
    }),
    isLoginModalOpen: ((state: Modal): boolean => {
        return state.isLoginModalOpen;
    }),
    isPictureModalOpen: ((state: Modal): boolean => {
        return state.isPictureModalOpen;
    }),
    isDeactivateModalOpen: ((state: Modal): boolean => {
        return state.isDeactivateModalOpen;
    }),
    isDeleteModalOpen: ((state: Modal): boolean => {
        return state.isDeleteModalOpen;
    }),
    isReactivateModalOpen: ((state: Modal): boolean => {
        return state.isReactivateModalOpen;
    }),
    isResetWizardModalOpen: ((state: Modal): boolean => {
        return state.isResetWizardModalOpen;
    }),
    isMasqueradeModalOpen: ((state:Modal): boolean => {
        return state.isMasqueradeModalOpen;
    }),
    isWarningModalOpen: ((state:Modal): boolean => {
        return state.isWarningModalOpen;
    }),
    isEditionModalOpen: ((state: Modal): boolean => {
        return state.isEditionModalOpen;
    }),
    windowScrollBarWidth: ((state: Modal): number => {
        return state.windowScrollBarWidth;
    }),
    getActivePicture: ((state: Modal) : Picture|null => {
        return state.activePicture;
    }),
    getCanBeClose: ((state:Modal): boolean => {
        return state.canBeClosed;
    }),
    getModalTitle: ((state:Modal): string|null|undefined => {
        return state.modalTitle;
    })
};

const actions: ActionTree<Modal, RootState> = {
    setModalTitle: function({commit}, modalTitle: string) {
        commit("setModalTitle", modalTitle);
    },
    openMasqueradeModal: function({commit}) {
        commit("openMasqueradeModal");
    },
    closeMasqueradeModal: function({commit}) {
        commit("closeMasqueradeModal");
    }
};

const modal: Module<Modal, RootState> = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};

export default modal;
